import { Component, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent {
    public Editor = ClassicEditor;
    public Editor2 = ClassicEditor;
    public Editor3 = ClassicEditor;
    public Editor4 = ClassicEditor;
    window:any= <any>window;
    $:any=<any>this.window.$;
    notification:any = {
      danger: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'danger'}}),
      success: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'success'}})
    };
    rand = (num:any = null) => {
      num = num || 12;
      var text = "";
      var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < num; i++) {
          text += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return text;
    };
    openModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`)?.children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'block');
    };
    closeModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`)?.children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'none');
    };
    queryparams:any = () => this.route.snapshot.queryParams;
    params:any = () => this.route.snapshot.params;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });
    updateView:any = () => {
        setTimeout(() => {
            if(this.queryparams()['group-selected']) {
                this.openModal('#gruppoModal');
            } else this.closeModal('#gruppoModal');
            this.cd.detectChanges();
        }, 50);
      };
    gruppo:any = {
        name: "",
        id: ""
    };
    constructor(
        private cd: ChangeDetectorRef,
        private route:ActivatedRoute,
        private router:Router,
        private zone: NgZone
    ) {
        route.queryParams.subscribe((p:any) => this.updateView());
        this.window.usher.element.addEventListener('change', this.updateView.bind(this));
    }

    ngOnDestroy() {
        this.window.usher.element.removeEventListener('change', this.updateView.bind(this));
    };

    getSettings = () => this.window.usher.get()?.configuration?.settings || {};

    getGroups = (id:any = undefined) => this.window.usher.getPublicConfiguration()?.groups?.filter(e => !id || e.id == id) || [];

    getGruppo = () => {
        if(!!this.queryparams()['group-selected'] && this.queryparams()['group-selected'] != 'new') return this.getGroups(this.queryparams()['group-selected'])[0] || this.gruppo;
        return this.gruppo;
    };

    update = async () => {
        try {
            this.window.usher.get().configuration.settings = this.window.usher.get().configuration.settings || {};
            await this.window.usher.get().update();
            this.notification.success({text: "Aggiornamento avvenuto con successo"});
        } catch(e) {
            console.log(e);
        }
    };

    initGruppo = () => {
        this.gruppo = {
            name: "",
            id: ""
        };
    };

    openGruppo = () => {
        this.router.navigate([`/settings`], { queryParams: this.changeQueryParam({ "group-selected" : 'new' }) });
    };
    
    closeGruppo = () => {
        if(this.queryparams()['group-selected']) this.router.navigate([`/settings`], { queryParams: this.changeQueryParam({ "group-selected" : undefined }) });
        this.initGruppo();
    };

    getGroupDocuments = async (input:any = undefined) => {

        this.window.flowup.signal.emit({name: 'get-files', detail: {
            event: input,
            callback: (parsed_files) => {
                this.window.flowup.signal.emit({name: 'upload-files', detail: {
                    collection: parsed_files,
                    callback: (sent) => {
                        // Assegno i documenti al gruppo
                    },
                    error: (file) => {
                        return this.notification.danger({text: `Errore nel caricamento del file ${file.filename}`});
                    }
                }});
            }
        }});
    };

    updateGruppo = () => {
        this.update();
        this.closeGruppo();
    };

    addGruppo = async () => {
        try {
            this.window.usher.get().public_configuration.groups = this.window.usher.get().public_configuration.groups || [];
            this.getGruppo().id = this.rand();
            this.window.usher.get().public_configuration.groups.push(this.getGruppo());
            await this.window.usher.get().update();
            this.closeGruppo();
            return this.notification.success({text: "Gruppo aggiunto con successo."});
        } catch(e) {
            console.log(e);
            return this.notification.danger({text: "Errore. Riprova più tardi."});
        }
    };

    openDeleteGruppo = () => {
        this.closeModal('#gruppoModal');
        this.openModal('#deleteGruppoModal');
    };

    closeDeleteGruppo = () => {
        this.closeModal('#deleteGruppoModal');
        this.openModal('#gruppoModal');
    };

    deleteGruppo = async () => {
        try {
            let ind = this.window.usher.get().public_configuration.groups?.findIndex(el => el.id == this.getGruppo().id);
            if(isNaN(ind)) return;
            this.window.usher.get().public_configuration.groups.splice(ind, 1);
            this.window.usher.getChildren().forEach(async el => {
                let index = el.public_configuration.groups?.findIndex(g => g.id == this.getGruppo().id);
                if(!isNaN(index)) {
                    el.public_configuration.groups.splice(index, 1);
                    await el.update();
                }
            });
            await this.window.usher.get().update();
            this.closeGruppo();
            this.closeModal('#deleteGruppoModal');
            return this.notification.success({text: "Gruppo eliminato con successo."});
        } catch(e) {
            console.log(e);
            return this.notification.danger({text: "Errore. Riprova più tardi."});
        }
    };

    getGroupCount = (gruppo:any) => this.window.usher.getChildren().filter(e => e.public_configuration.groups?.find(el => el.id == gruppo.id))?.length || 0;
}